import { HttpClient, HttpEvent, HttpRequest } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { XhrService } from '@blaze-shared/platform-data-access';

import { FileItem, ResourceResult } from '../../../domain/public-api';
import { mapToMimeType } from '../../../util/public-api';

export interface UploadStartData {
  filename: string;
  mime: string;
  accountId: string;
  projectId?: string;
  isSecure?: boolean;
  category?: 'None' | 'Icon';
}

export interface UploadStartResult {
  uploadUrl: string;
  id: string;
}

export interface UploadStatusResponse {
  results: ResourceResult[];
}

@Injectable({ providedIn: 'root' })
export class UploadApiService {
  private readonly httpClient = inject(HttpClient);
  private readonly xhrService = inject(XhrService);

  startUpload(
    accountId: string,
    fileItems: FileItem[],
    projectId?: string,
    isSecure?: boolean,
    category?: 'None' | 'Icon',
  ): Observable<UploadStartResult[]> {
    const startUploadData: UploadStartData[] = fileItems.map<UploadStartData>((fileItem) => {
      const mime = mapToMimeType(fileItem.file, fileItem.name);
      return { filename: fileItem.name, mime, accountId, projectId, isSecure, category };
    });

    return this.xhrService.post<UploadStartResult[]>('media/upload/start', startUploadData);
  }

  upload(file: File | Blob, url: string): Observable<HttpEvent<void>> {
    const request = new HttpRequest('PUT', url, file, { reportProgress: true });
    request.headers.set('ngsw-bypass', 'true');
    return this.httpClient.request(request);
  }

  end(resourceIds: string[]): Observable<void> {
    return this.xhrService.post<void>('media/upload/end', resourceIds);
  }

  checkResourceStatuses(resourceIds: string[]): Observable<UploadStatusResponse> {
    return this.xhrService.post<UploadStatusResponse>('media/upload/status', resourceIds);
  }

  confirmResources(resourceIds: string[]): Observable<string[]> {
    return this.xhrService.post<string[]>('media/upload/confirm', resourceIds);
  }
}
